import { ClassCtor } from './../types/classctor.type';
import { declareDto } from './delcare-dto.util';

export function exportDto<Type>(obj: ClassCtor): Type {
    return declareDto(obj.prototype) as Type;
}
